<template>
  <IForm class="i-search" inline :model="model" :elem="elem" :loading="loading" :btn-loading="btnLoading" :label-position="labelPosition"
         :label-width="labelWidth" @on-submit="handleSearch" @on-reset="handleSearch" :btn-label-width="4" :submit="submit"
         submit-text="查询" ok-icon="md-search" btn-icon="md-refresh" @on-changestart="changestart" @on-changeend="changeend">
    <slot slot="head" name="head" />
    <slot />
    <slot slot="button" name="button" />
  </IForm>
  <!-- IForm -->
</template>
<script>
export default {
  name: "Search",
  props: {
    model: Object,
    elem: Array,
    loading: Boolean,
    btnLoading: Boolean,
    labelWidth: Number,
    submit: {
      type: Boolean,
      default:()=>{
        return true;
      }
    },
    labelPosition: {
      validator(value) {
        const validList = ["left", "right", "top"];
        for (let i = 0; i < validList.length; i++) {
          if (value === validList[i]) {
            return true;
          }
        }
        return false;
      },
      default: "right"
    }, // 表单域标签位置
  },
  data: () => ({}),
  methods: {
    handleSearch() {
      this.$emit("on-search", true);
    },
    changestart(e){
      this.$emit("on-changestart", e);

    },
    changeend(e,propName){
      this.$emit("on-changeend", e,propName);

    }
  }
};
</script>
<style lang="postcss">
.i-search .ivu-form-item {
  margin-bottom: 16px;
  vertical-align: bottom;
}
</style>
